import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type PrescriptionIconProps = Partial<SVGIconProps>;

const PrescriptionIcon: FC<PrescriptionIconProps> = (props) => (
  <SVGIcon viewBox="0 0 143 142" {...props}>
    <path
      d="M99.922 102.182l-2.093 2.093 2.093 2.092 12.397 12.391c.137.138.246.301.321.481a1.49 1.49 0 0 1 0 1.134c-.075.18-.184.343-.321.481s-.301.246-.481.321-.373.113-.567.113a1.49 1.49 0 0 1-.567-.113c-.18-.074-.343-.183-.48-.321l-12.392-12.397-2.092-2.093-2.092 2.093-12.391 12.397a1.48 1.48 0 0 1-2.095 0 1.48 1.48 0 0 1-.001-2.095l12.397-12.392 2.093-2.092-2.092-2.092-28.844-28.844-.866-.867h-1.225-15.914-2.958v2.958 31.063c0 .392-.156.768-.433 1.045s-.654.434-1.046.434-.769-.156-1.046-.434-.433-.653-.433-1.045V22.181a1.48 1.48 0 0 1 1.479-1.479h28.84c6.557.017 12.864 2.521 17.646 7.008s7.684 10.624 8.117 17.168-1.634 13.009-5.784 18.088-10.073 8.393-16.573 9.272l-5.917.801 4.221 4.222 22.825 22.831 2.092 2.093 2.092-2.093 12.391-12.397a1.48 1.48 0 0 1 2.096 0c.277.278.434.655.434 1.048a1.48 1.48 0 0 1-.434 1.047l-12.397 12.391zM44.708 23.66H41.75v2.958 39.938 2.958h2.958 24.406c6.081 0 11.912-2.416 16.212-6.715s6.715-10.131 6.715-16.212-2.416-11.912-6.715-16.212-10.131-6.715-16.212-6.715H44.708z"
      stroke="currentColor"
      strokeWidth="5.917"
    />
  </SVGIcon>
);

export default PrescriptionIcon;
